import React from 'react';
import { useNavigate } from 'react-router-dom';

function ProfilePage({ user, onLogout }) {
  const navigate = useNavigate();

  const handleLogout = () => {
    onLogout();
    navigate('/login');
  };

  return (
    <div className="page-container">
      <h1>Profile</h1>
      <div className="profile-card">
        <p><strong>Name:</strong> {user?.first_name || user?.firstName || 'N/A'} {user?.last_name || user?.lastName || ''}</p>
        <p><strong>Email:</strong> {user?.email || 'N/A'}</p>
        <p><strong>Role:</strong> {user?.role || 'N/A'}</p>
        <p><strong>Status:</strong> {user?.status || 'active'}</p>
      </div>
      <button className="btn btn-primary" onClick={handleLogout}>Logout</button>
    </div>
  );
}

export default ProfilePage;
